<template>
  <div class="teachin-details" v-if="model">
      <div class="teachin-details__title">{{ $t(model.label) }}</div>
      <ul class="teachin-details__settings">
        <li>
          <Checkbox :isSimple="false" hideDetails :disabled="model.showAlways" :label="$t('TEACH-IN-ACTIVE-LABEL')" :value="model.active" @updatedValue="changeActiveFlag" />
        </li>
        <template v-if="model.settings && model.settings.length >0">
          
        <li v-for="(setting, index) in model.settings">
          <template v-if="setting.type === 'boolean'">
            <Checkbox hideDetails :isSimple="false" :label="$t(setting.label)" :value="setting.value" @updatedValue="changeSettingFlag(index, $event)" /> 
          </template>
          <v-tooltip top v-if="setting.description">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          style="padding-left: 1px; margin-bottom: -6px"
          v-bind="attrs"
          small
          color="#1B99A7"
          v-on="on"
        >
          mdi-information-outline
        </v-icon>
      </template>
      <span>{{ $t(setting.description) }}</span>
    </v-tooltip>
        </li>

      </template>
      </ul>
  </div>
</template>

<script>
import {cloneDeep, isEqual} from 'lodash';
import Checkbox from '../../../components/ui-elements/Checkbox.vue';
  export default {
    name: 'TeachinStepDetails',
    components: {Checkbox},
    props:{
      step:{
        type: Object
      }
    },
    data(){
      return {
        model: null
      }
    },
    computed:{

    },
    watch:{
      step:{
        handler(el, oldEl){
          if(isEqual(el, oldEl))return;
          this.init();
        },
        deep: true
      },
    },
    methods:{
      init(){
        this.model = cloneDeep(this.step);
      },
      changeSettingFlag(index, value){
        this.model.settings[index] = Object.assign(this.model.settings[index], {value});
        this.$emit('syncModel', cloneDeep(this.model));
       
      },
      changeActiveFlag(status){
        this.model.active = status;
        this.$emit('syncModel', cloneDeep(this.model));
      }
    }
  }
</script>

<style lang="scss" scoped>
  .teachin-details{
    width: 100%;
    display: flex;
    flex-direction: column;
    &__title{
      padding: .5em;
      flex: 1;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #1B99A7;
      color: #fff;
      font-family: Arial, sans-serif;
      font-size: 14px;
      line-height: 16.1px;
      font-weight: 700;
    }

    &__settings{
      margin: .5em 0 0;
      padding: 0 .5em 0 0;

      & li{
        list-style: none;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        word-break: break-all;
        font-family: Arial, sans-serif;
        font-size: 12px;
        line-height: 16.1px;
        font-weight: 400;
      }
    }
  }
</style>
